import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { db } from '../config/firebase';
import { collection, addDoc } from 'firebase/firestore';
import '../components/styles/layout.css';

const Layout = ({ children }) => {
  // Navigation state
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [expandedItems, setExpandedItems] = useState([]);
  const [activeDropdown, setActiveDropdown] = useState(null);
  
  // Newsletter state
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });

  const navigate = useNavigate();

  const menuItems = {
    left: [
      {
        label: 'ABOUT US',
        key: 'about',
        href: '/about',
        items: [
          { label: 'About Me', href: '/about' },
          { label: 'Educational', href: '/products' },
        ]
      },
      {
        label: 'SERVICES',
        key: 'services',
        href: '/wedding',
        items: [
          { label: 'Weddings', href: '/wedding' },
          { label: 'Glam', href: '/glam' },
          { label: 'Editorial', href: '/editorial' },
          { label: 'Pricing', href: '/pricing' }
        ]
      }
    ],
    right: [
      {
        label: 'PORTFOLIO',
        key: 'portfolio',
        href: '/photo-gallery',
        items: []
      },
      {
        label: 'CONTACT',
        key: 'contact',
        href: '/contact',
        items: []
      }
    ],
    mobile: [
      {
        label: 'HOME',
        key: 'home',
        href: '/',
        items: []
      },
      {
        label: 'ABOUT US',
        key: 'about',
        items: [
          { label: 'About Me', href: '/about' },
          { label: 'Educational', href: '/products' },
        ]
      },
      {
        label: 'SERVICES',
        key: 'services',
        items: [
          { label: 'Weddings', href: '/wedding' },
          { label: 'Glam', href: '/glam' },
          { label: 'Editorial', href: '/editorial' },
          { label: 'Pricing', href: '/pricing' }
        ]
      },
      {
        label: 'PORTFOLIO',
        key: 'portfolio',
        href: '/photo-gallery',
        items: []
      },
      {
        label: 'CONTACT',
        key: 'contact',
        href: '/contact',
        items: [{ label: 'Booking', href: '/booking' },]
      }
    ]
  };

  // Navigation handlers
  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setExpandedItems([]);
  };

  const handleMobileItemClick = (item) => {
    if (item.items?.length > 0) {
      toggleExpandItem(item.label);
    } else if (item.href) {
      navigate(item.href);
      setIsMobileMenuOpen(false);
      setExpandedItems([]);
    }
  };

  const toggleExpandItem = (item) => {
    setExpandedItems(prev => 
      prev.includes(item) ? prev.filter(i => i !== item) : [...prev, item]
    );
  };

  // Newsletter handler
  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    try {
      const docRef = await addDoc(collection(db, 'newsletter_subscribers'), {
        ...formData,
        isActive: true,
        subscribedAt: new Date().toISOString()
      });

      setFormData({ firstName: '', lastName: '', email: '' });
      console.log('Newsletter subscription successful, ID:', docRef.id);
    } catch (error) {
      console.error('Error subscribing to newsletter:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Navigation link renderer
  const renderDesktopNavLinks = (items) => {
    return items.map((item) => (
      <div
        key={item.key}
        className="nav-link"
        onMouseEnter={() => setActiveDropdown(item.key)}
        onMouseLeave={() => setActiveDropdown(null)}
      >
        <Link to={item.href || '#'}>{item.label.toLowerCase()}</Link>
        {activeDropdown === item.key && item.items?.length > 0 && (
          <div className="dropdown-menu">
            {item.items.map((subItem) => (
              <Link
                key={subItem.href}
                to={subItem.href}
                className="dropdown-item"
                onClick={() => setActiveDropdown(null)}
              >
                {subItem.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    ));
  };

  return (
    <div className="site-wrapper">
      {/* Navigation */}
      <nav className="nav-container">
        <div className="nav-content">
          <button 
            className="mobile-menu-button"
            onClick={toggleMobileMenu}
            aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
          >
            <div className="hamburger-lines">
              <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
              <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
              <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
            </div>
          </button>

          <div className="desktop-nav">
            <div className="nav-links left-links">
              {renderDesktopNavLinks(menuItems.left)}
            </div>

            <Link to="/" className="nav-logo" onClick={handleLogoClick}>
              <img src="/butterfly.png" alt="Logo" />
            </Link>

            <div className="nav-links right-links">
              {renderDesktopNavLinks(menuItems.right)}
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-content">
          <div className="menu-items">
            {menuItems.mobile.map((item) => (
              <div key={item.key} className="menu-item">
                <div 
                  className="menu-item-header"
                  onClick={() => handleMobileItemClick(item)}
                >
                  {item.href ? (
                    <Link 
                      to={item.href}
                      className="menu-item-title"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsMobileMenuOpen(false);
                      }}
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <span className="menu-item-title">{item.label}</span>
                  )}
                  {item.items?.length > 0 && (
                    <span className="menu-toggle">
                      {expandedItems.includes(item.label) ? '-' : '+'}
                    </span>
                  )}
                </div>
                {expandedItems.includes(item.label) && item.items?.length > 0 && (
                  <div className="submenu">
                    {item.items.map((subItem) => (
                      <Link
                        key={subItem.href}
                        to={subItem.href}
                        className="submenu-item"
                        onClick={() => {
                          setIsMobileMenuOpen(false);
                          setExpandedItems([]);
                        }}
                      >
                        {subItem.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="social-icons">
            <a href="mailto:INFO@MAKEUPBYLORREN.COM" className="social-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
              </svg>
            </a>
            <a href="https://www.facebook.com/profile.php?id=61573442401332" className="social-icon" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"/>
              </svg>
            </a>
            <a href="https://www.instagram.com/makeup_by_lorren/" className="social-icon" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>

              </svg>
            </a>
          </div>
        </div>
      </div>

      <main>{children}</main>

      {/* Footer */}
      <footer className="footer">
        {/* Newsletter Section */}
        <div className="newsletter-section">
          <p className="newsletter-text">
            Please sign up to complete a survey and receive future promotions!
          </p>
          <form onSubmit={handleNewsletterSubmit} className="newsletter-form">
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleInputChange}
              placeholder="First Name"
              className="newsletter-input"
              required
            />
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleInputChange}
              placeholder="Last Name"
              className="newsletter-input"
              required
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Email Address"
              className="newsletter-input"
              required
            />
            <button type="submit" className="newsletter-button">
              SUBSCRIBE
            </button>
          </form>
        </div>

        <div className="footer-container">
          <div className="quick-links">
            <h3 className="quick-links-title">Quick Links</h3>
            <nav className="quick-links-nav">
              <Link to="/contact">Get in Touch</Link>
              <Link to="/faq">FAQ</Link>
            </nav>
          </div>

          <div className="footer-center">
            <div className="social-links">
              <a href="mailto:INFO@MAKEUPBYLORREN.COM" className="social-link">
                <svg className="social-icon" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"/>
                </svg>
              </a>
              <a href="https://www.facebook.com/profile.php?id=61573442401332" target="_blank" rel="noopener noreferrer" className="social-link">
                <svg className="social-icon" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/makeup_by_lorren/" target="_blank" rel="noopener noreferrer" className="social-link">
                <svg className="social-icon" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C14.717 2 15.056 2.01 16.122 2.06C17.187 2.11 17.912 2.277 18.55 2.525C19.21 2.779 19.766 3.123 20.322 3.678C20.8305 4.1779 21.224 4.78259 21.475 5.45C21.722 6.087 21.89 6.813 21.94 7.878C21.987 8.944 22 9.283 22 12C22 14.717 21.99 15.056 21.94 16.122C21.89 17.187 21.722 17.912 21.475 18.55C21.2247 19.2178 20.8311 19.8226 20.322 20.322C19.822 20.8303 19.2173 21.2238 18.55 21.475C17.913 21.722 17.187 21.89 16.122 21.94C15.056 21.987 14.717 22 12 22C9.283 22 8.944 21.99 7.878 21.94C6.813 21.89 6.088 21.722 5.45 21.475C4.78233 21.2245 4.17753 20.8309 3.678 20.322C3.16941 19.8222 2.77593 19.2175 2.525 18.55C2.277 17.913 2.11 17.187 2.06 16.122C2.013 15.056 2 14.717 2 12C2 9.283 2.01 8.944 2.06 7.878C2.11 6.812 2.277 6.088 2.525 5.45C2.77524 4.78218 3.1688 4.17732 3.678 3.678C4.17767 3.16923 4.78243 2.77573 5.45 2.525C6.088 2.277 6.812 2.11 7.878 2.06C8.944 2.013 9.283 2 12 2Z"/>
                  <a href="https://www.tiktok.com/@makeup_by_lorren" className="social-icon" target="_blank" rel="noopener noreferrer">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C13.13 2 14.21 2.28 15.17 2.8V7.16C15.17 7.97 15.86 8.67 16.67 8.67C17.76 8.67 18.69 8.32 19.42 7.75V10.34C18.28 10.77 17.04 10.95 15.83 10.84V14.25C15.83 17.32 13.32 19.83 10.25 19.83C7.18 19.83 4.67 17.32 4.67 14.25C4.67 11.53 6.56 9.28 9.08 8.72V11.45C8.02 11.92 7.33 12.98 7.33 14.25C7.33 15.94 8.73 17.33 10.42 17.33C12.11 17.33 13.5 15.94 13.5 14.25V2H12Z"/>
                  </svg>
                  </a>

                </svg>
              </a>
            </div>
            <p className="footer-description">
              I'm Lorren, a passionate makeup artist offering a variety of services to bring out your natural beauty. Feel free to browse through my portfolio and get in touch to book a consultation. I believe that makeup should enhance your features and reflect your unique style, whether it's for a special event or a glam.
            </p>
          </div>

          {/* Contact Information */}
          <div className="contact-info">
            <p className="contact-text">Canada</p>
            <p className="contact-text">North York</p>
            <p className="contact-text">(Toronto)</p>
            <p className="contact-text contact-spacer">9:00 am - 5:00 pm, Monday-Friday.</p>
            <p className="contact-text secondary">& weekends by special appointment</p>
            <p className="contact-text contact-spacer">Phone: 647-553-9724</p>
            <p className="contact-text contact-spacer">Email: INFO@MAKEUPBYLORREN.COM</p>
          </div>
        </div>

        <div className="footer-copyright">
          <p>©2025 Copyright Makeup By Lorren | Site designed by A.M Digital Creations LTD</p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;